// extracted by mini-css-extract-plugin
export var busy = "GooglePayButton-module--busy--b1ae1";
export var clickCapture = "GooglePayButton-module--clickCapture--985bc";
export var container = "GooglePayButton-module--container--36b01";
export var gpay = "GooglePayButton-module--gpay--7c048";
export var processingOverlay = "GooglePayButton-module--processingOverlay--23196";
export var small = "GooglePayButton-module--small--7c803";